import React from 'react';

// This is the Font Awesome icon for pen-regular resized to 32x32
// This is specifically used for the mouse cursor
export default function PenRegular({fillColor}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32}>
      <g id="surface1">
        <path
          style={{stroke: 'none', fillRule: 'nonzero', fill: fillColor, fillOpacity: 1}}
          d="M 2.273438 22.554688 L 0.835938 27.4375 L 0.0625 30.074219 C -0.09375 30.605469 0.0507812 31.175781 0.4375 31.5625 C 0.824219 31.949219 1.394531 32.09375 1.917969 31.945312 L 4.5625 31.164062 L 9.445312 29.726562 C 10.21875 29.5 10.925781 29.105469 11.53125 28.574219 C 11.617188 28.5 11.699219 28.417969 11.78125 28.335938 L 30.792969 9.332031 C 32.164062 7.960938 32.332031 5.855469 31.304688 4.300781 C 31.164062 4.082031 30.988281 3.867188 30.792969 3.675781 L 28.332031 1.207031 C 26.769531 -0.355469 24.238281 -0.355469 22.675781 1.207031 L 3.664062 20.21875 C 3.011719 20.867188 2.539062 21.675781 2.273438 22.554688 Z M 5.148438 23.398438 C 5.257812 23.050781 5.429688 22.726562 5.675781 22.449219 C 5.710938 22.414062 5.742188 22.375 5.78125 22.335938 L 20.0625 8.0625 L 23.9375 11.9375 L 9.664062 26.21875 C 9.367188 26.511719 9 26.730469 8.601562 26.851562 L 7.136719 27.28125 L 3.710938 28.289062 L 4.71875 24.863281 Z M 5.148438 23.398438"
        />
      </g>
    </svg>
  );
}
